//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.service('SocialSearchBarService', [
    'ContentFilterTypes',
    function(
            ContentFilterTypes,
        ) {
      this.generatePrefixedString = function(filterObj) {
        switch (filterObj.type) {
          case ContentFilterTypes.HASHTAG:
            return `#${filterObj.value}`;
          case ContentFilterTypes.USERNAME:
            return `@${filterObj.value}`;
          default:
            return filterObj;
        }
      };
    },
  ]);
})();
